/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as core from '../../../../core';
import * as serializers from '../../../index';

export const Request: core.serialization.Schema<serializers.desk.didCommMessageRecv.Request.Raw, string> =
    core.serialization.string();

export declare namespace Request {
    export type Raw = string;
}
